import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { PhoneIcon, SideArrow } from "../common/icons/svg";
import equal from "fast-deep-equal";
import { getDateFormatted4, setLang } from "../../common/common";
import moment from "moment";
import { renderImg } from "../common/icons/img";
import { getImgPath, getImgPath2 } from "../common/helper";
import {
  EMAIL,
  ENG,
  FRANCHISEE,
  KND,
  MITRA,
  OP,
  SRA,
  TYB1,
  TYB2,
  WLCM_KSRTC,
  t,
  CO,
  LO,
  MY,
  AC,
} from "../../translations/HeaderNew";
import { EN, KN } from "../../common/constants";

let _lang = window.lang;
class HeaderNonSrp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headertext1: [],
      headertext2: [],
      ftSz: window.localStorage.getItem("ksrtcFtsz")
        ? window.localStorage.getItem("ksrtcFtsz")
        : "original",
    };
    this.updatedata = this.updatedata.bind(this);
  }

  componentDidMount() {
    this.updatedata();
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props.search.header, prevProps.search.header)) {
      this.updatedata();
    }
  }

  updatedata() {
    if (Object.keys(this.props.search.header).length > 0) {
      this.setState({
        headertext1: this.props.search.header.text1,
        headertext2: this.props.search.header.text2,
      });
    }
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    let headertext1 = [];
    let headertext2 = [];
    const prop = this.props.search;
    const order = prop.order;
    const Bookingnumber = window.Bookingcontact ? window.Bookingcontact : false;
    const othernumber = window.otherContact ? window.otherContact : false;
    const welcomeMsg = window.welcomeMsg ? window.welcomeMsg : false;
    const contactNo = window.contactNo ? window.contactNo : false;
    let trip = prop.searchParams.mode;
    const urlParams = new URLSearchParams(window.location.search);
    const inSrp =
      window.location.pathname && window.location.pathname.indexOf("/search");
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    if (prop.searchParams.mode === "roundtrip") {
      trip = "Return trip";
      if (!prop.searchParams.token) {
        trip = "Onward trip";
      }
    } else {
      trip = "Onward trip";
    }
    let fromcity = "",
      tocity = "";
    if (prop) {
      fromcity = prop.searchParams.fromCity
        ? prop.searchParams.fromCity.split("|")[1]
        : "";
      tocity = prop.searchParams.toCity
        ? prop.searchParams.toCity.split("|")[1]
        : "";
    }
    if (Object.keys(order).length > 0) {
      if (trip === "Onward trip") {
        fromcity = order.onward.fromCity;
        tocity = order.onward.toCity;
      }
      if (trip === "Return trip") {
        if (order.return && order.return.seats) {
          fromcity = order.return.fromCity;
          tocity = order.return.toCity;
        }
      }
    }
    if (this.state.headertext1.length > 0) {
      headertext1 = this.state.headertext1;
    } else {
      headertext1 = fromcity + " - " + tocity;
    }
    if (this.state.headertext2.length > 0) {
      headertext2 = this.state.headertext2;
    } else {
      headertext1 = trip;
    }

    const onwardData = order && order.onward;
    const returnData = order && order.return;
    return (
      <div className="header--section">
        {this.props.type !== "branch" && (
          <div className="header-screen-reader">
            <div className="header-screen-reader-left">
              {welcomeMsg} |&nbsp;<span>&#9742;</span>&nbsp;{contactNo}
            </div>
            <div className="header-screen-reader-right">
              <div className="block1">{t(SRA)}</div>
              <div className="block2">
                <div
                  id="large"
                  className={this.state.ftSz == "large" ? "active" : ""}
                  onClick={() => setFontSize("large")}
                >
                  A+
                </div>
                <div
                  id="original"
                  className={`brdlr ${this.state.ftSz == "original" ? "active" : ""
                    }`}
                  onClick={() => setFontSize("original")}
                >
                  A
                </div>
                <div
                  id="small"
                  className={this.state.ftSz == "small" ? "active" : ""}
                  onClick={() => setFontSize("small")}
                >
                  A-
                </div>
              </div>
              <div className="block3">
                <div onClick={() => setThemeColor("SC")}>SC</div>
                <div className="line">|</div>
                <div onClick={() => setThemeColor("HC")}>HC</div>
              </div>
              <div className="block4">
                <div
                  className="circle-orange"
                  onClick={() => setThemeColor("orange")}
                ></div>
                <div
                  className="circle-blue"
                  onClick={() => setThemeColor("blue")}
                ></div>
                <div
                  className="circle-green"
                  onClick={() => setThemeColor("green")}
                ></div>
                <div
                  className="circle-black"
                  onClick={() => setThemeColor("brown")}
                ></div>
              </div>
              {/* <div className="block5">
                <div
                  className={`left ${_lang == EN ? "active" : ""}`}
                  onClick={() => {
                    setLang(EN);
                  }}
                >
                  {t(ENG)}
                </div>
                <div className="center">|</div>
                <div
                  className={`right ${_lang == KN ? "active" : ""}`}
                  onClick={() => {
                    setLang(KN);
                  }}
                >
                  {t(KND)}
                </div>
              </div> */}
            </div>
          </div>
        )}
        <div className="header-top-wrapper">
          <div className="header-logo">
            <a href="/">
              <img
                src={window.awsImagePath + window.Searchlogo}
                alt={window.companyName}
                width="368"
                height="68"
              />
            </a>
          </div>
          {this.props.type !== "branch" && (
            <div className="header-right" style={{ width: "45%" }}>
              <div className="header-right-item">
                {!window.customerProfile.isLoggedIn ? (
                  <a className="nonSrp-link" href="/login">
                    <div>
                      <img id="imgLoginAccount" src={getImgPath("/img/login_account.svg")} />
                    </div>
                    <div className="header-right-item-text">
                      {t(CO)} <br />
                      {t(LO)}
                    </div>
                  </a>
                ) : (
                  <a className="nonSrp-link" href="/account" style={{ maxWidth: '150px' }}>
                    <div>
                      <img id="imgLoginAccount" src={getImgPath("/img/login_account.svg")} />
                    </div>
                    <div className="header-right-item-text" style={{maxWidth:"150px"}}>
                      {/* {t(MY)} <br />
                      {t(AC)} */}
                      {window.customerProfile.CustomerName && this.capitalizeFirstLetter(window.customerProfile.CustomerName)}
                    </div>
                  </a>
                )}
              </div>
              <div className="header-right-item">
                <a
                  className="nonSrp-link"
                  href="https://awatar4.ksrtc.in/"
                  target="_blank"
                >
                  <div>
                    <img id="imgOpfr" src={getImgPath("/img/opfr.svg")} />
                  </div>

                  <div className="header-right-item-text">
                    {t(OP)} / <br />
                    {t(FRANCHISEE)}
                  </div>
                </a>
              </div>
              <div className="header-right-item">
                <a
                  className="nonSrp-link"
                  href="https://login.microsoftonline.com"
                  target="_blank"
                >
                  <div>
                    <img id="imgEmail" src={getImgPath("/img/email.svg")} />
                  </div>
                  <div className="header-right-item-text">
                    KSRTC <br />
                    {t(EMAIL)}
                  </div>
                </a>
              </div>
              {/*<div className="header-right-item">
                              <a
                                className="nonSrp-link"
                                href="http://vtms.ksrtc.in/KSRTC-VTMS_new/"
                                target="_blank"
                              >
                                <div>
                                  <img id="imgTrackBus"  src={getImgPath("/img/trackbus.svg")} />
                                </div>
                                <div className="header-right-item-text">
                                  {t(TYB1)} <br />
                                  {t(TYB2)}
                                </div>
                              </a>
                            </div>
              <div className="header-right-item">
                <a
                  className="nonSrp-link"
                  href="http://mitra.ksrtc.in/MysoreMBus/"
                  target="_blank"
                >
                  <div>
                    <img id="imgMitra"  src={getImgPath("/img/mitra.svg")} />
                  </div>
                  <div className="header-right-item-text">{t(MITRA)}</div>
                </a>
              </div>*/}
              <div className="header-right-item">
                <a
                  className="nonSrp-link"
                  href="https://ksrtchelp.freshdesk.com/"
                  target="_blank"
                >
                  <div>
                    <img id="imgCrm" src={getImgPath("/img/crm.svg")} />
                  </div>
                  <div className="header-right-item-text">CRM</div>
                </a>
              </div>
              <div
                className="header-right-item"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <a
                  href="https://play.google.com/store/apps/details?id=com.ksrtc.awatar.new&hl=en&pli=1"
                  target="_blank"
                >
                  {renderImg("google_play_store")}
                </a>
                <a
                  href="https://apps.apple.com/us/app/ksrtc-awatar/id1250082402?ign-mpt=uo%3D4"
                  target="_blank"
                >
                  {renderImg("apple_store_non_srp")}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = function (store) {
  return store;
};
export default connect(mapStateToProps)(withRouter(HeaderNonSrp));
